import { useState } from 'react';
import { api } from '../lib/api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const user = await api.post('/api/auth/login', { username, password });
      onLogin(user);
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <div className="app">
      <div className="screen" style={{ paddingTop: 64, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img src="/vardhate-logo-blue-full.png" alt="Vardhate Logo" style={{ height: 80, maxWidth: '100%', objectFit: 'contain' }} />
          <p className="muted" style={{ marginTop: 8, marginBottom: 0 }}>Sign in to continue</p>
        </div>
        <form className="card" style={{ width: '100%', maxWidth: 400 }} onSubmit={submit}>
          {error && <div className="err">{error}</div>}
          <div className="field">
            <label>Username</label>
            <input autoCapitalize="none" autoCorrect="off" value={username} onChange={(e) => setUsername(e.target.value)} />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button className="btn" type="submit" disabled={busy || !username || !password}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
